import { getProductTextBadge } from '@/features/shop/utils/getProductTextBadge'
import styled from 'styled-components'
import { ProductTextBadge } from '@/features/shop/components/ProductTextBadge'
import { SquareBadge } from '@/features/shared/elements/Badges'
import { type Product } from '@/features/shop/services/Product/types'
import { useIsProductSnapEbtEligible } from '@/features/shared/hooks/useIsProductSnapEbtEligible'

type Props = {
  product: Product
  productQuantity: number
}

export const ProductDetailBadges = ({ product, productQuantity }: Props) => {
  const { nutrition_attributes_for_you, is_snap_ebt_eligible } = product
  const isEbtEligible = useIsProductSnapEbtEligible(is_snap_ebt_eligible)

  const { showProductTextBadge, productTextBadges, purchaseLimit } = getProductTextBadge(product, {
    isEbtEligible,
  })
  if (!showProductTextBadge) return null

  return (
    <FlagPillAndBadgeWrapper>
      <FlagPillWrapper>
        <ProductTextBadge
          productTextBadges={productTextBadges}
          productQuantity={productQuantity}
          purchaseLimit={purchaseLimit}
        />
      </FlagPillWrapper>
      {nutrition_attributes_for_you.length > 0 && (
        <NutritionWrapper>
          {nutrition_attributes_for_you.map((match) => (
            <DescribeNutritionAttribute key={match.tag}>
              <SquareBadge as="span">{match.tag}</SquareBadge>
            </DescribeNutritionAttribute>
          ))}
        </NutritionWrapper>
      )}
    </FlagPillAndBadgeWrapper>
  )
}

const NutritionWrapper = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`

const DescribeNutritionAttribute = styled.li`
  display: inline-block;
  margin: 0.25rem 0.25rem 0.25rem 0;
`

const FlagPillWrapper = styled.div`
  flex-basis: 100%;
  height: auto;
  order: 2;
`

const FlagPillAndBadgeWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0;
`
